const txt = [
  [
    "Мы должны найти их. Я позвоню Эрику, он поможет мне.",
    "We have to find them. I will call Eric. He will help me",
  ],
  ["Я отправлю тебе местоположение", "I will send you the location."],
  ["Я скоро буду", "I am coming soon"],
  [
    "Не расстраивайся. Все будет хорошо скоро",
    "Don't be upset. Everything will be fine soon",
  ],
  ["Мы скоро поженимся", "We are going to marry soon"],
  ["да, это особенный день для нас.", "Yes. It is very special day for us"],
  [
    "она взрослая девушка. Мы убедим ее",
    "She is mature girl. We will convince her",
  ],
  ["Мы пойдем за покупками.", "We will go shopping"],
  ["Успокойся. Как я могу помочь?", "Calm down. How can I help you?"],
  [
    "Ты зашел слишком далеко. Я пытался тебя остановить",
    "You have gone too far. I tried to stop you",
  ],
  ["ты преувеличиваешь", "you are exaggerating"],
  ["она врала мне. Она предала меня.", "She lied to me. She betrayed me"],
  [
    "Нам следует пойти домой. Мы не можем обсуждать наши проблемы тут.",
    "We should go home. We cannot discuss our issues here",
  ],
  [
    "Почему ты не сказал мне об этом раньше?",
    "Why did not you tell me before about it?",
  ],
];

export default txt;
